import React, { forwardRef } from 'react';
import BaseSelect from '../base-select';
import { APPEARANCES, SIZES } from '../base-select/constants';
import { SEARCHABLE_SELECT_PROPS } from './types';
import LoadingIndicator from './loading-indicator';

const SearchableSelect = forwardRef(
  (
    {
      size = SIZES.small,
      id = null,
      name = null,
      placeholder = '',
      noResultsText = '',
      options = [],
      defaultValue = null,
      value,
      clearable = false,
      disabled = false,
      invalid = false,
      preventOverflow = false,
      onChange = Function.prototype,
      onBlur = Function.prototype,
      onFocus = Function.prototype,
      onInputChange = Function.prototype,
      openMenuOnFocus = false,
      filterOptionsFunction = null,
      asyncConfig = null,
      menuPlacement = 'auto',
      maxMenuHeight = null,
    },
    ref
  ) => (
    <BaseSelect
      ref={ref}
      appearance={APPEARANCES.searchable}
      size={size}
      asyncConfig={asyncConfig}
      withDropdownIndicator
      components={{
        LoadingIndicator: asyncConfig ? LoadingIndicator : null,
      }}
      inputId={id}
      name={name}
      placeholder={placeholder}
      noResultsText={noResultsText}
      options={options}
      defaultValue={defaultValue}
      value={value}
      clearable={clearable}
      disabled={disabled}
      invalid={invalid}
      preventOverflow={preventOverflow}
      onChange={onChange}
      onBlur={onBlur}
      onFocus={onFocus}
      onInputChange={onInputChange}
      openMenuOnFocus={openMenuOnFocus}
      filterOptionsFunction={filterOptionsFunction}
      menuPlacement={menuPlacement}
      maxMenuHeight={maxMenuHeight}
    />
  )
);

SearchableSelect.propTypes = SEARCHABLE_SELECT_PROPS;

SearchableSelect.displayName = 'SearchableSelect';

export default SearchableSelect;
